/**
 * Full Referrer Cookie Logic with Fallback Handling
 * Stores the original referrer in a cookie for 30 minutes
 * Includes fallback message if referrer is missing (e.g., direct URL)
 */

class Cookies {
    constructor() {
        this.defaultExpiry = 30; // days
        this.domain = window.location.hostname;
    }

    static async init() {
        // console.log('🍪 Cookies component initialized');
        const cookies = new Cookies();
        window.BrookfieldCookies = cookies;
        // cookies.setOriginalReferrer();
        await cookies.setDniSource();
    }


    async setDniSource() {
        const cookieName = "dni_source";
        
        // Check current cookie value for debugging
        const currentCookie = this.get(cookieName);
        
        // Get UTM source from URL
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');
        
        // Get referrer and extract domain
        const referrer = document.referrer;
        let referrerDomain = '';
        
        if (referrer && referrer !== '') {
            try {
                const referrerUrl = new URL(referrer);
                referrerDomain = referrerUrl.hostname.replace(/^www\./, ''); // Remove www. prefix
                
            } catch (e) {
                referrerDomain = referrer; // Use full referrer as fallback
            }
        }
        
        // Debug logging
      
        

        
        // Clean the UTM source value - remove surrounding quotes if present and decode URL encoding
        let cleanUtmSource = utmSource;
        if (utmSource) {
            
            // First decode URL encoding (e.g., %20 -> space)
            cleanUtmSource = decodeURIComponent(utmSource);
            
            // Then remove surrounding quotes if present
            if (cleanUtmSource.startsWith('"') && cleanUtmSource.endsWith('"') || cleanUtmSource.startsWith("'") && cleanUtmSource.endsWith("'")) {
                cleanUtmSource = cleanUtmSource.slice(1, -1); // Remove first and last character (quotes)
            } 
            
            // Normalize the source name for consistent matching
            const normalizedSource = this.normalizeSourceName(cleanUtmSource);
            cleanUtmSource = normalizedSource; // Update cleanUtmSource with normalized value
          
        } 
        
        
        // Step 1: If we have a UTM source, try to find exact match in the database
        if (cleanUtmSource) {
           
            try {
                const dbResult = await this.lookupDniSource(cleanUtmSource, referrerDomain);
                if (dbResult) {
                    
                    // Only set dni_source cookie if it doesn't already exist
                    if (!this.exists(cookieName)) {
                        this.set(cookieName, dbResult.source, 180); // 180 days expiration
                    } else {
                        const existingSource = this.get(cookieName);
                    }
                    
                    // Only set dni_referrer cookie if it doesn't already exist
                    if (!this.exists('dni_referrer')) {
                        // If referral_url is empty, use fallback referrer value
                        if (dbResult.referral_url && dbResult.referral_url.trim() !== '') {
                            this.set('dni_referrer', dbResult.referral_url, 180); // 180 days expiration
                        } else {
                            this.set('dni_referrer', 'Property referrer', 180); // 180 days expiration
                        }
                    } else {
                        const existingReferrer = this.get('dni_referrer');
                    }
                    
                    return;
                } else {
                    // If UTM source lookup failed, only set fallback if no cookie exists
                    this.setFallbackCookies(false); // Only set if cookie doesn't exist
                    return;
                }
            } catch (error) {
                // Database error, only set fallback if no cookie exists
                this.setFallbackCookies(false); // Only set if cookie doesn't exist
                return;
            }
        }
        
        // Step 2: If we have a referrer but no UTM source, try to find it in the database
        if (referrerDomain && !cleanUtmSource) {
            try {
                const dbResult = await this.lookupDniSource(null, referrerDomain);
                if (dbResult) {
                    // Only set dni_source cookie if it doesn't already exist
                    if (!this.exists(cookieName)) {
                        this.set(cookieName, dbResult.source, 180); // 180 days expiration
                    } else {
                        const existingSource = this.get(cookieName);
                    }
                    
                    // Only set dni_referrer cookie if it doesn't already exist
                    if (!this.exists('dni_referrer')) {
                        // If referral_url is empty, use fallback referrer value
                        if (dbResult.referral_url && dbResult.referral_url.trim() !== '') {
                            this.set('dni_referrer', dbResult.referral_url, 180); // 180 days expiration
                        } else {
                            this.set('dni_referrer', 'Property referrer', 180); // 180 days expiration
                        }
                    } else {
                        const existingReferrer = this.get('dni_referrer');
                    }
                    
                    return;
                } 
            } catch (error) {
                // console.log('[DNI] ⚠️ Referrer database lookup failed:', error);
            }
        }
        
        // Step 3: Fallback to default values when no database match found
        this.setFallbackCookies(false); // Only set if cookie doesn't exist
    }

    setFallbackCookies(forceUpdate = false) {
        const cookieName = "dni_source";
        const dniSourceValue = 'Property website';
        
        
        if (!this.exists(cookieName) || forceUpdate) {
            // Set both source and referrer cookies (fallback)
            this.set(cookieName, dniSourceValue, 180); // 180 days expiration
            this.set('dni_referrer', 'Property referrer', 180); // 180 days expiration
        } else {
            const existingSource = this.get(cookieName);
            
            // Always ensure dni_referrer cookie is set, even if dni_source already exists
            if (!this.exists('dni_referrer')) {
                this.set('dni_referrer', 'Property referrer', 180); // 180 days expiration
            } else {
                const existingReferrer = this.get('dni_referrer');
            }
        }
    }

    async lookupDniSource(sourceName, referrerDomain) {
        try {
            // Get the WordPress site URL dynamically - use WordPress REST API root
            let apiUrl;
            
            if (window.wpApiSettings && window.wpApiSettings.root) {
                apiUrl = window.wpApiSettings.root.replace('/wp-json/', '/wp-json/dni/v1/lookup');
            } else {
                // Fallback: build API URL based on current location
                const currentPath = window.location.pathname;
                let sitePath = '';
                
                
                // For staging/production, use root path (no additional path needed)
                if (window.location.hostname === 'cron-staging.brookfield.qburst.build') {
                    sitePath = '';
                }
                // For local development with brookfield-portfolio-website path
                else if (window.location.hostname === 'localhost' && currentPath.includes('/brookfield-portfolio-website/')) {
                    sitePath = '/brookfield-portfolio-website';
                }
                // For other environments, check if brookfield-portfolio-website path exists
                else if (currentPath.includes('/brookfield-portfolio-website/')) {
                    sitePath = '/brookfield-portfolio-website';
                }
                // Default: no additional path
                
                
                apiUrl = window.location.origin + sitePath + '/wp-json/dni/v1/lookup';
            }
            
            
            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({
                        source: sourceName,
                        referrer: referrerDomain
                    })
                    // Removed AbortController and timeout to test if that's the issue
                });
                
                if (!response.ok) {
                    return null;
                }
                
                const responseText = await response.text().catch(() => null);
                if (!responseText) {
                    return null;
                }
                
                
                let data;
                try {
                    data = JSON.parse(responseText);
                } catch (parseError) {
                    return null;
                }
                
                // Check if the response indicates no match found
                if (!data.success) {
                    return null;
                }
                
                const result = data.data;
                return result;
                
            } catch (error) {
                return null;
            }
        } catch (error) {
            return null;
        }
    }

    set(name, value, days = this.defaultExpiry, path = '/', domain = null, secure = false) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        
        // Debug logging for encoding
        // Use a custom encoding that preserves spaces and common characters
        const encodedValue = value.replace(/[;,\s]/g, function(match) {
            if (match === ' ') return ' ';
            if (match === ';') return '\\;';
            if (match === ',') return '\\,';
            return match;
        });
        
        // console.log('[DNI] 🔍 Encoded value:', encodedValue);
        
        let cookieString = name + '=' + encodedValue + expires + '; path=' + path + '; SameSite=Lax';
        if (domain) cookieString += '; domain=' + domain;
        if (secure) cookieString += '; secure';
        document.cookie = cookieString;
    }

    get(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                const value = cookie.substring(nameEQ.length);
                // Decode our custom encoding
                const decodedValue = value.replace(/\\;/g, ';').replace(/\\,/g, ',');
                return decodedValue;
            }
        }
        return null;
    }

    exists(name) {
        return this.get(name) !== null;
    }

    delete(name, path = '/', domain = null) {
        this.set(name, '', -1, path, domain);
        // console.log('🍪 Cookie deleted:', name);
    }
    
    /**
     * Normalize source name for consistent matching
     * Removes hyphens, underscores, spaces and converts to lowercase
     */
    normalizeSourceName(name) {
        if (!name) return '';
        return name
            .replace(/[-_]+/g, ' ')   // replace hyphens/underscores with space
            .replace(/\s+/g, ' ')     // collapse multiple spaces
            .trim();     
    }
}

// Run it immediately
Cookies.init();
